<template>
  <div class="edit-tag-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="100px" label-position="left">
        <div class="imgbox">
          <el-form-item label="封面:" prop="coverImg">
            <base-upload
              :cover="params.coverImg"
              :action="action"
              @successCallback="successCallback"
              :wSize="360"
              :hSize="360"
            ></base-upload>
          </el-form-item>        
          <el-form-item label="背景图:" prop="backgroundImg">
            <base-upload
              :cover="params.backgroundImg"
              :action="action"
              @successCallback="successBgImgCallback"
              :wSize="180"
              :hSize="90"
              :width="'180px'"
              :height="'90px'"
            ></base-upload>
          </el-form-item>       
        </div> 
        <el-form-item label="标签名:" prop="name">
          <el-input v-model.trim="params.name" size="small"></el-input>
        </el-form-item>
        <el-form-item label="描述:" prop="tagDesc">
          <el-input v-model.trim="params.tagDesc" size="small"></el-input>
        </el-form-item>
        <el-form-item label="播放量(假):" prop="fakePlayCount" v-if="type === 'edit'">
          <el-input v-model.number="params.fakePlayCount" size="small"></el-input>
        </el-form-item>
        <el-form-item label="精彩排序号:" prop="wonderSortCode" v-if="type === 'edit'">
          <el-input v-model.number="params.wonderSortCode" size="small"></el-input>
        </el-form-item>
                <el-form-item label="常用排序号:" prop="usedSortCode" v-if="type === 'edit'">
          <el-input v-model.number="params.usedSortCode" size="small"></el-input>
        </el-form-item>
        <el-form-item label="推送至发现:" prop="isWonder">
          <el-switch v-model="params.isWonder"></el-switch>
        </el-form-item>
        <el-form-item label="是否常用:" prop="isCommonUsed">
          <el-switch v-model="params.isCommonUsed"></el-switch>
        </el-form-item>
        <el-form-item label="是否启用:" prop="isActive">
          <el-switch v-model="params.isActive"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm()" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { validatorIndex, validatorLanguage } from "@/utils/validator";
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      type: "",
      // 提交状态
      flag: false,
      id: "",
      // 封面、背景图片上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      // 表单数据
      params: {
        coverImg: "",
        backgroundImg: "",
        name: "",
        tagDesc: "",
        sortCode: 0,
        isWonder: false,
        isCommonUsed: false,
        isActive: false,
        fakePlayCount: 0,
        wonderSortCode: 0,
        usedSortCode:0
      },
      // 表单验证规则
      rules: {
        name: [
          { required: true, message: "请输入标签名称", trigger: "blur" },
          { validator: validatorLanguage, trigger: "blur" }
        ],
        sortCode: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" }
        ],
        sortKey: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" }
        ],
        fakeRating: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" }
        ],
        fakeCollCount: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" }
        ],
        wonderSortCode: [
          { required: true, message: "请输入精彩排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" }
        ],
        coverImg: [{ required: false, message: "请上传封面图", trigger: "blur" }],
        backgroundImg: [{ required: false, message: "请上传背景图", trigger: "blur" }],
      }
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addTags();
          } else {
            this.editTag();
          }
        } else {
          return false;
        }
      });
    },
    // 添加标签
    addTags() {
      API.addTags(this.params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            this.$emit("handlerTagList");
          } else {
            this.$message.error("添加失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑标签
    editTag() {
      if (this.params.coverImg == "" || this.params.coverImg == null) {
        this.params.coverImg = "xxx"
      }
      if (this.params.backgroundImg == "" || this.params.backgroundImg == null) {
        this.params.backgroundImg = "xxx"
      }
      let params = Object.assign(this.params, { id: this.id });
      API.editTags(params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success"
            });
            this.$emit("handlerTagList");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 标签封面上传成功回掉
    successCallback(res) {
      this.params.coverImg = res.data.coverImg;
    },
    // 标签背景图上传成功回掉
    successBgImgCallback(res) {
      this.params.backgroundImg = res.data.coverImg;
    },
    // 关闭弹窗
    handleClose() {
      this.params = {
        coverImg: "",
        backgroundImg: "",
        name: "",
        tagDesc: "",
        sortCode: 0,
        isWonder: false,
        isCommonUsed: false,
        isActive: false,
        fakePlayCount: 0,
        wonderSortCode: 0,
        usedSortCode:0
      };
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      this.type = type;
      if (type === "edit") {
        this.title = "编辑标签";
        this.params = JSON.parse(JSON.stringify(data));
        this.id = data.id;
      } else {
        this.title = "新增标签";
      }
    }
  }
};
</script>

<style lang="scss" >
.edit-tag-box {
  .el-dialog {
    margin-top: 100px !important;
  }
  .imgbox {
    display: flex;
  }
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>

